<template>
    <div style="">
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <p class="pTitle">教师认证</p>
                            <div style="margin-top: 2em;">
                                <div v-if="status === -2">
                                    <p style="margin-top: 30px;margin-bottom: 30px;">我要成为老师？</p>
                                    <div style="font-size: 14px;color: #999999;">认证为恒点mool云平台教师</div>
                                    <div style="font-size: 14px;color: #999999;margin-top: 10px;">
                                        成为恒点mool云平台教师后可申请入驻其它学校
                                    </div>
                                    <div style="margin-top: 30px;">
                                        <el-button type="primary" plain="plain" size="mini" @click="begin">开始认证
                                        </el-button>
                                    </div>
                                </div>
                                <div style="margin-top: 100px;position: relative;" v-if="status === 1">
                                    <div
                                        style="background-color: #f7f7f8;display: flex;border-bottom:13px #dddfde solid;border-radius: 5px;">
                                        <div style="width: 180px;">
                                            <div style="position: absolute;top: -60px;left: 30px;">
                                                <div style="text-align: center;position: relative;">
                                                    <img :src="avatar" alt=""
                                                         style="height: 120px;width: 120px;border-radius: 5px;box-shadow: 0px 0px 12px 1px #CCCCCC;">
                                                    <span
                                                        style="background-color: #fac65c;color: #b57d02;font-size: 12px;padding: 2px 5px;border-radius: 3px;position: absolute;top: 0;right: 0;">教师</span>
                                                </div>
                                                <div style="text-align: center;color: #333333;margin-top: 10px;">
                                                    {{ username }}
                                                </div>
                                                <div
                                                    style="text-align: center;font-size: 14px;color:#999999;margin-top: 10px;">
                                                    {{ rank }}
                                                </div>
                                            </div>
                                        </div>
                                        <div style="flex: 1;padding-right: 1.5em;font-size: 14px;">
                                            <div
                                                style="border-bottom:1px #dddfde solid;padding-top: 10px;padding-bottom: 10px;">
                                                个人简介：
                                            </div>
                                            <div
                                                style="color: #666666;margin-top: 1.5em;margin-bottom: 1em;min-height: 5em;">
                                                {{ intro }}
                                            </div>
                                        </div>
                                    </div>
                                    <img src="../../assets/images/center/yi_ren_zheng.png" alt=""
                                         style="width:65px;height:65px;position: absolute;right: 5px;top:5px;">
                                </div>
                                <div v-if="status === -1">
                                    <p style="color: #f56c6c;">
                                        <i class="el-icon-warning"
                                           style="font-size: 2em;position: relative;top: 5px;margin-right: 10px;"></i>您的申请未通过
                                    </p>
                                    <el-form label-position="left" label-width="50px">
                                        <el-form-item class="itemForm" label="原因:">
                                            <div style="line-height: 25px;position: relative;top:8px;width: 500px;">
                                                {{ reject }}
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                    <p style="font-size: 14px;color:#999999;margin-top: 30px;margin-bottom: 30px;">
                                        建议您修改资料，再次提交审核，如有疑问，请联系客服：<span style="color: #00a4e0;">025-88888888</span></p>
                                    <div style="margin-top: 30px;">
                                        <el-button type="primary" size="mini" @click="goEdit">修改资料</el-button>
                                    </div>
                                </div>
                                <div v-if="status === 0">
                                    <p style="color: #00a4e0;">
                                        <i class="el-icon-circle-check"
                                           style="font-size: 2em;position: relative;top: 5px;margin-right: 10px;"></i>您的申请已发送
                                    </p>
                                    <p style="color: #999999;font-size: 14px;">学校将在1-2个工作日内完成审核</p>
                                </div>
                            </div>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'

export default {
    name: 'UserTeacherCer',
    components: {
        HdHeader,
        HdFooter,
        HdAside
    },
    created () {
        this.getUser()
        let that = this
        if (!this.isEmpty(localStorage.getItem('avatar'))) {
            that.avatar = localStorage.getItem('avatar')
        }
    },
    mounted () {
        this.$nextTick(function () {
            let that = this
            window.addEventListener('storage', (e) => {
                switch (e.key) {
                    case 'avatar':
                        if (that.avatar !== e.newValue) {
                            that.avatar = e.newValue
                        }
                        break
                }
            })
            window.addEventListener('setItemEvent', (e) => {
                if (e.key === 'avatar') {
                    if (that.avatar !== e.newValue) {
                        that.avatar = e.newValue
                    }
                }
            })
        })
    },
    data () {
        return {
            isTeacher: false,
            avatar: '',
            username: '',
            schoolName: '',
            rank: '',
            intro: '',
            reject: '',
            status: -2
        }
    },
    methods: {
        getUser () {
            let that = this
            //教师认证之前，必须做完实名认证
            this.$ajax.get('/api/teacher/getbyuid').then(function (res) {
                if (!that.isEmpty(res.data)) {
                    that.username = res.data.username
                    that.schoolName = res.data.school_name
                    that.rank = res.data.rank
                    that.intro = res.data.intro
                    that.reject = res.data.reject
                    that.status = res.data.status
                }
            })
        },
        begin () {
            this.$router.push('/user-teacher-agreement')
        },
        goEdit () {
            this.$router.push('/user-teacher-info')
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.pTitle {
    border-bottom: 1px solid #d6d6da;
    padding-bottom: 10px;
}

.itemForm {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserTeacherCer.vue